import React, { useEffect } from 'react';
import styles from '../../Balance.module.scss';
import classnames from 'classnames';
import { isEmpty, clone } from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import { Dispatch } from 'redux';
//components
import { getItemName, formatNumber } from '../../Utils/dashboardUtils';
import { BalanceTableItem } from './BalanceTableItem';
import { CsvDownloaderHandler } from '../../Utils/CsvDownloadHandler';
//data
import { dashboardActions } from '../../../../store/dashboard/actions';
//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';

import { Balance } from '../../../../sagas/dashboard/types';

export const BalanceTable: React.FC<any> = (props) => {
  const cx = classnames.bind(styles);
  const { t } = useTranslation();
  const {
    transactionsData,
    isLoading,
    isRequested,
    navigateToPage,
    page,
    setPage,
    userId,
    getAllCsvPayouts,
    downloadAllCsv,
    dashboardState,
  } = props;
  // const CustomTooltip = withStyles(theme => ({
  //   tooltip: {
  //     backgroundColor: ' #242424',
  //     boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.3)',
  //     padding: 18,
  //     fontSize: 12,
  //   },
  //   arrow: {
  //     color: ' #242424',
  //   },
  // }))(Tooltip);

  useEffect(() => {
    getAllCsvPayouts({
      download_type: 'payouts',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nextPage = () => {
    setPage(page + 1);
    navigateToPage(transactions[transactions.length - 1].ID);
  };
  const previousPage = () => {
    setPage(page - 1);
  };
  const limit = 50;
  const fromIndex = page === 1 ? 0 : (page - 1) * limit;
  const toIndex = page === 1 ? limit : fromIndex + limit;

  const transactions = isEmpty(transactionsData) ? undefined : transactionsData;
  const groupTransactionsByDate: () => any = () => {
    let newObj = clone(transactions).reduce(
      (h: any, obj: any) =>
        Object.assign(h, {
          [moment(obj.created_at).format('DD/MM/YYYY')]: (
            h[moment(obj.created_at).format('DD/MM/YYYY')] || []
          ).concat(obj),
        }),
      {},
    );

    const keys = Object.keys(newObj);
    return keys.map((key) => (
      <div key={key}>
        <div className={styles.header}>
          <label>{key}</label>
        </div>
        {newObj[key].map((transaction: Balance, index: number) => {
          return (
            <BalanceTableItem
              transaction={transaction}
              key={transaction.ID + index}
            />
          );
        })}
      </div>
    ));
  };
  const isDisabled = !transactions || transactions.length < limit * page;

  return (
    <>
      <div className={styles.tableWrapper}>
        <div className={styles.flex}>
          <h2>{tr(t, 'payment-history')}</h2>
          <CsvDownloaderHandler
            data={downloadAllCsv}
            properties={'payouts'}
            userId={userId}
            isLoading={dashboardState.isLoadingCsv}
          />
        </div>

        <div className={styles.table}>
          <div className={cx(styles.tableHeader, styles.payoutsTableHeader)}>
            <label>{tr(t, 'date')}</label>
            <label>{tr(t, 'type')}</label>
            <label>{tr(t, 'amount')}</label>
            {/* <label>{tr(t, 'receipt')}</label> */}
          </div>
          <div className={styles.tableItems}>
            {isLoading ? (
              <div className={styles.emptyState}>
                <label>{tr(t, 'loading')}...</label>
              </div>
            ) : transactions ? (
              transactions
                .slice(fromIndex, toIndex)
                .map((transaction: Balance, index: number) => {
                  return (
                    <div
                      key={transaction.ID + index}
                      className={cx(styles.tableItem, styles.payoutsTableItem)}
                    >
                      <label>{transaction.createdAt.format('DD/MM/YY')}</label>

                      <label>
                        {getItemName(transaction.type, transaction.metadata, t)}
                      </label>
                      <label>{transaction.netIncome.toString()}</label>
                    </div>
                  );
                })
            ) : (
              <div className={styles.emptyState}>
                <label>{tr(t, 'no-data')}</label>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.tableWrapperMobile}>
        <h2>{tr(t, 'payment-history')}</h2>
        <CsvDownloaderHandler
          data={downloadAllCsv}
          properties={'payouts'}
          userId={userId}
          isLoading={dashboardState.isLoadingCsv}
        />
        {!isRequested ? (
          <div className={styles.emptyState}>
            <label>Loading...</label>
          </div>
        ) : transactions ? (
          <div>{groupTransactionsByDate()}</div>
        ) : (
          <div className={styles.emptyState}>
            <label>{tr(t, 'no-data')}</label>
          </div>
        )}
      </div>
      <div className={styles.navigationBtnWrapper}>
        <button disabled={page === 1} onClick={() => previousPage()}>
          {page !== 1 && tr(t, 'previous')}
        </button>
        <label>
          {tr(t, 'page')} {page}
        </label>
        <button
          className={isDisabled ? styles.hidden : styles.next}
          disabled={isDisabled}
          onClick={() => nextPage()}
        >
          {tr(t, 'next')}
        </button>
        {isLoading && (
          <label className={styles.mobileLoading}>{tr(t, 'loading')}...</label>
        )}

        <button
          disabled={isDisabled}
          className={styles.mobileBtn}
          onClick={() => nextPage()}
        >
          {tr(t, 'see-more')}
        </button>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  dashboardState: state.dashboard,
  loginState: state.login,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getAllCsvPayouts: (queryparams: any) =>
    dispatch(dashboardActions.downloadAllCsvRequestAction(queryparams)),
});

export const BalanceTableConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BalanceTable);
